import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PricingPage } from './pages/PricingPage';
import { ThesisPage } from './pages/resources/ThesisPage';
import { SolutionsPage } from './pages/SolutionsPage';
import { QualityPage } from './pages/solutions/QualityPage';
import { ManufacturingMESPage } from './pages/solutions/ManufacturingMESPage';
import { InventoryManagementPage } from './pages/solutions/InventoryManagementPage';
import { SalesQuotingPage } from './pages/solutions/SalesQuotingPage';
import { PurchasingPage } from './pages/solutions/PurchasingPage';
import { CustomPage } from './pages/solutions/CustomPage';
import { ManufacturingPage } from './pages/industries/ManufacturingPage';
import { IndustrialOperationsPage } from './pages/industries/IndustrialOperationsPage';
import { ConsumerProductsPage } from './pages/industries/ConsumerProductsPage';
import { BiotechPage } from './pages/industries/BiotechPage';
import { AboutUsPage } from './pages/about/AboutUsPage';
import { PartnerPage } from './pages/about/PartnerPage';
import { CareersPage } from './pages/about/CareersPage';
import { IntegrationsPage } from './pages/resources/IntegrationsPage';
import { BlogPage } from './pages/resources/BlogPage';
import { BlogPostPage } from './pages/resources/BlogPostPage';
import { CaseStudiesPage } from './pages/resources/CaseStudiesPage';
import { CaseStudyPage } from './pages/resources/CaseStudyPage';
import { DemoVideosPage } from './pages/resources/DemoVideosPage';
import { TermsPage } from './pages/TermsPage';
export function App() {
  return <HashRouter data-id="element-0">
      <div className="min-h-screen w-full bg-navy" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutUsPage data-id="element-8" />} data-id="element-7" />
            <Route path="/about/careers" element={<CareersPage data-id="element-10" />} data-id="element-9" />
            <Route path="/partners" element={<PartnerPage data-id="element-12" />} data-id="element-11" />
            <Route path="/pricing" element={<PricingPage data-id="element-14" />} data-id="element-13" />
            <Route path="/resources/thesis" element={<ThesisPage data-id="element-16" />} data-id="element-15" />
            <Route path="/resources/integrations" element={<IntegrationsPage data-id="element-18" />} data-id="element-17" />
            <Route path="/resources/blog" element={<BlogPage data-id="element-20" />} data-id="element-19" />
            <Route path="/resources/blog/:slug" element={<BlogPostPage data-id="element-22" />} data-id="element-21" />
            <Route path="/resources/case-studies" element={<CaseStudiesPage data-id="element-24" />} data-id="element-23" />
            <Route path="/resources/case-studies/:slug" element={<CaseStudyPage data-id="element-26" />} data-id="element-25" />
            <Route path="/resources/demo-videos" element={<DemoVideosPage data-id="element-28" />} data-id="element-27" />
            <Route path="/solutions" element={<SolutionsPage data-id="element-30" />} data-id="element-29" />
            <Route path="/solutions/quality" element={<QualityPage data-id="element-32" />} data-id="element-31" />
            <Route path="/solutions/manufacturing-mes" element={<ManufacturingMESPage data-id="element-34" />} data-id="element-33" />
            <Route path="/solutions/inventory-management" element={<InventoryManagementPage data-id="element-36" />} data-id="element-35" />
            <Route path="/solutions/sales-and-quoting" element={<SalesQuotingPage data-id="element-38" />} data-id="element-37" />
            <Route path="/solutions/purchasing" element={<PurchasingPage data-id="element-40" />} data-id="element-39" />
            <Route path="/solutions/custom" element={<CustomPage data-id="element-42" />} data-id="element-41" />
            <Route path="/industries/manufacturing" element={<ManufacturingPage data-id="element-44" />} data-id="element-43" />
            <Route path="/industries/industrial-operations" element={<IndustrialOperationsPage data-id="element-46" />} data-id="element-45" />
            <Route path="/industries/consumer-products" element={<ConsumerProductsPage data-id="element-48" />} data-id="element-47" />
            <Route path="/industries/biotech" element={<BiotechPage data-id="element-50" />} data-id="element-49" />
            <Route path="/terms" element={<TermsPage data-id="element-52" />} data-id="element-51" />
          </Routes>
        </main>
        <Footer data-id="element-53" />
      </div>
    </HashRouter>;
}